import { Modal, ModalBody, ModalFooter, Button, Form, Select } from "@gpstrackit/react-controls";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState, useRef, useMemo } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from 'react-router-dom'

//Controls
import { NotificationManager } from 'Components/Notifications';
import { Checkbox, Tabs, TabContainer } from "@gpstrackit/react-controls";
import { Alert, AlertTitle } from '@mui/material';
import CustomSelect from 'Components/Select';

//Permission
import { HasPermission } from "Core/security";

import { copyToClipboard } from 'Core/data/Helpers';

import {
    Icon,
    OutlinedInput,
    InputAdornment,
    FormControl,
    Radio,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';
import { getGtcAccounts } from 'Modules/importAccount/views/main/.components/newMigration/redux/saga';
import {
    clearRedux,
    importAccountSearchRequest,
    importAccountRequest,
    accountsGetImportByPxRequest,
    searchEntityRequest,
    importAccountGetStatusRequest,
    importAccountGetMigrationAccountRequest
} from 'Redux/actions';

//Styles
import './index.scss';
import { set } from "lodash";

// Constants
const ENTITY_KEYS = ["accounts", "groups", "drivers", "devices", "contacts", "geofences", "landmark_groups", "landmarks", "alerts"];
const GTC_ENTITY_KEYS = [
    "devices",
    "asset",
    "driver",
    "user"
];

const NewMigration = (props) => {
    const { getData } = props
    const { messages } = useIntl()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const formRef = useRef(null);
    const formRefTSO = useRef(null);
    const [tab, setTab] = useState(0)
    const [openSearch, setOpenSearch] = useState("")
    const [externalAccount, setExternalAccount] = useState(null)
    const [noSearch, setNoSearch] = useState(false)
    const [internalAccount, setInternalAccount] = useState(null)
    const [newInternalAccount, setNewInternalAccount] = useState(null)
    const [server, setServer] = useState(null);
    const [importSource, setImportSource] = useState(null);
    const [step, setStep] = useState(1);
    const [entityTSO, setEntityTSO] = useState(false);
    const [entityP4, setEntityP4] = useState(false);
    const [entityGTC, setEntityGTC] = useState(false);
    const [gtcAccount, setGtcAccount] = useState(null);
    const [integrationMode, setIntegrationMode] = useState(null);
    const [upgradeConfirmOpen, setUpgradeConfirmOpen] = useState(false);
    const [previewLocked, setPreviewLocked] = useState(false);
    const [gtcEntities, setGtcEntities] = useState(() =>
        GTC_ENTITY_KEYS.reduce((acc, key) => ({ ...acc, [key]: false }), {})
    );

    const toggleGtcEntity = (key) => {
        setGtcEntities(prev => ({ ...prev, [key]: !prev[key] }));
    }

    const requestIntegrationModeChange = (nextMode) => {
        // Si ya se hizo upgrade, no permitir cambiar
        if (migrationAccount?.mode === 'upgrade') {
            return;
        }

        // Lógica original
        if (nextMode === 'preview' && previewLocked) return;
        if (nextMode === 'upgrade' && integrationMode !== 'upgrade') {
            setUpgradeConfirmOpen(true);
            return;
        }
        setIntegrationMode(nextMode);
    }

    //Entities Migration
    const [accounts, setAccounts] = useState(true)
    const [categories, setCategories] = useState(false)
    const [devices, setDevices] = useState(false)
    const [drivers, setDrivers] = useState(false)
    const [contacts, setContacts] = useState(false)
    const [behavior, setBehavior] = useState(false)
    const [users, setUsers] = useState(false)
    const [geofences, setGeofences] = useState(false)
    const [alerts, setAlerts] = useState(false)
    const [maintenance, setMaintenance] = useState(false)
    const [speedOverrides, setSpeedOverrides] = useState(false)

    const [entities, setEntities] = useState(() =>
        ENTITY_KEYS.reduce((acc, key) => ({ ...acc, [key]: key === "accounts" }), {})
    );

    const handleCheckboxChange = (key) => {
        setEntities(prev => ({ ...prev, [key]: !prev[key] }));
    };

    //Redux Store
    const {
        accountsList,
        loading,
        openModal,
        result,
        status,
        pxAccount,
        migrationAccount,
        internalMigratedAccount,
        legacyAccountCodes
    } = useSelector(state => state.newMigrationRedux)

    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux)
    const sources = useSelector(state => state.generalRedux.sources);
    const loadingEntity = useSelector(state => state.syncEntitiesSelectorRedux.loadingEntity);
    const user = useSelector(state => state.securityRedux.user);

    // Filter sources based on user permissions
    const filteredSources = useMemo(() => {
        if (!sources || !sources.length) return [];

        return sources.filter(source => {
            // Check specific permission for each source type
            const sourceId = source.id?.toUpperCase();

            switch (sourceId) {
                case 'P4':
                    return HasPermission(user, "mgrtnsp4", "c");
                case 'TSO':
                    return HasPermission(user, "mgrtnstso", "c");
                case 'GTC':
                    return HasPermission(user, "mgrtnsgtc", "c");
                default:
                    return false;
            }
        });
    }, [sources, user]);

    //Close window
    const closeModal = () => {
        setTab(0);
        setOpenSearch("");
        setExternalAccount(null);
        setNoSearch(false);
        setContacts(false);
        setCategories(false);
        setBehavior(false);
        setUsers(false);
        setDevices(false);
        setGeofences(false);
        setMaintenance(false);
        setDrivers(false);
        setAlerts(false);
        setInternalAccount(null);
        setServer(null);
        setNewInternalAccount(null);
        setSpeedOverrides(false);
        dispatch(clearRedux("IMPORT_ACCOUNT"));
        setImportSource(null);
        setEntityTSO(false);
        setEntityP4(false);
        setEntityGTC(false);
        setIntegrationMode(null);
        setUpgradeConfirmOpen(false);
        setPreviewLocked(false);
        setGtcEntities(GTC_ENTITY_KEYS.reduce((acc, key) => ({ ...acc, [key]: false }), {}));
    }
    //Obtain PX accounts
    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    //Start a new migration
    const handleSaveP4 = () => {
        let entitiesP4 = ["accounts"]

        //Validation of entities
        if (contacts) entitiesP4.push("contacts")
        if (categories) entitiesP4.push("categories")
        if (behavior) entitiesP4.push("behavior")
        if (users) entitiesP4.push("users")
        if (devices) entitiesP4.push("devices")
        if (geofences) entitiesP4.push("geofences")
        if (maintenance) entitiesP4.push("maintenance_tasks")
        if (drivers) entitiesP4.push("drivers")
        if (alerts) entitiesP4.push("alerts")
        if (speedOverrides) entitiesP4.push("road_speed_overrides")

        let payload = {
            sourcePlatform: server.id,
            externalCompanyId: externalAccount.id,
            entities: entitiesP4,
        }

        if (internalAccount?.id && (status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists")) {
            payload.pairWithCompanyId = internalAccount.id
        }

        dispatch(importAccountRequest(payload))

    }

    const handleSaveTSO = () => {
        try {
            let newEntities = []
            const selectedEntities = Object.entries(entities)
                .filter(([_, value]) => value)
                .map(([key]) => key);

            let payload = {
                sourcePlatform: importSource?.id.toUpperCase(),
                externalCompanyId: externalAccount.CompanyID,
                entities: selectedEntities,
            }

            if (internalAccount?.id && (status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists")) {
                payload.pairWithCompanyId = internalAccount.id
            }
            dispatch(importAccountRequest(payload))

        } catch (error) {
            NotificationManager.error(
                messages['new_migration_error_messages'],
                messages['new_migration_title'],
                3000
            );
        }
    };

    const handleSaveGTC = () => {
        const selectedEntities = integrationMode === 'upgrade'
            ? [...GTC_ENTITY_KEYS]
            : Object.entries(gtcEntities)
                .filter(([_, value]) => value)
                .map(([key]) => key);

        let payload = {
            sourcePlatform: importSource?.id,
            externalCompanyId: gtcAccount?.id,
            pairWithCompanyId: internalAccount?.id,
            entities: selectedEntities,
            mode: integrationMode,
        }

        dispatch(importAccountRequest(payload))
    }

    const getGtcAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getGtcAccounts(input).then((response) => {
            callback(response)
        })
    }

    useEffect(() => {
        if (status && (status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists")) {
            dispatch(accountsGetImportByPxRequest(externalAccount.name))
        }
    }, [status])

    useEffect(() => {
        if (pxAccount) {
            setInternalAccount(pxAccount);
            setNewInternalAccount(pxAccount);
            dispatch(clearRedux("IMPORT_ACCOUNT", { pxAccount: null }))
        }
        if (result) {

            dispatch(clearRedux("IMPORT_ACCOUNT", { result: null }))
            if (result?.stepFunctionId) {
                let transactionId = result.transactionId;
                let message = messages["new_migration_transaction_request_message"]
                NotificationManager.success(message, messages['new_migration_import_from_account'], 10000, () => {
                    copyToClipboard(transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${transactionId}`);

                }, null, '', null);
                getData();
                closeModal();

            } else if (result?.error) {
                let message = messages["new_migration_error_message"]
                if (result?.error?.error) {
                    if (messages[result.error.error])
                        message = messages[result.data.error.error]
                    else
                        message = result.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                }
                NotificationManager.error(
                    message,
                    messages['new_migration_import_from_p4'],
                    6000
                );
            }
        }
    }, [pxAccount, result])

    let validateStatus = status === "MigrationNotExists" && externalAccount?.name && internalAccount?.name && internalAccount?.name !== externalAccount?.name

    useEffect(() => {
        (!sources || sources.length === 0) && dispatch(searchEntityRequest({ key: "sources", fields: ["entityName"], terms: ["importProcess"] }));
    }, []);

    useEffect(() => {
        if (migrationAccount && internalMigratedAccount) {
            setInternalAccount(internalMigratedAccount);
            // Si ya existe una migración, configurar el modo según lo que ya existe
            if (migrationAccount.mode) {
                setIntegrationMode(migrationAccount.mode);
                if (migrationAccount.mode === 'upgrade') {
                    setPreviewLocked(true);
                    setGtcEntities(GTC_ENTITY_KEYS.reduce((acc, key) => ({ ...acc, [key]: true }), {}));
                } else {

                    let entities = JSON.parse(JSON.parse(migrationAccount.entities))
                    if (typeof entities === "string") {
                        entities = JSON.parse(entities);
                    }
                    setGtcEntities(prev => {
                        let newState = { ...prev };
                        entities.forEach(entity => {
                            if (GTC_ENTITY_KEYS.includes(entity)) {
                                newState[entity] = true;
                            }
                        });
                        return newState;
                    })
                }
            }
        }
        
        if (legacyAccountCodes) {
            if (legacyAccountCodes.length > 1) {
                NotificationManager.warning(
                    messages['new_migration_warning_multiple_legacy_accounts'],
                    messages['new_migration_title'],
                    8000
                );
            } else if (legacyAccountCodes.length === 0) {
                NotificationManager.warning(
                    messages['new_migration_gtc_account_missing_account_code'],
                    messages['new_migration_title'],
                    8000
                );
                setGtcAccount(null);
                setInternalAccount(null);
                dispatch(clearRedux("IMPORT_ACCOUNT", { accountsList: [], migrationAccount: null, internalMigratedAccount: null, legacyAccountCodes: null }));
            }
        }
    }, [migrationAccount, internalMigratedAccount, legacyAccountCodes]);

    return (
        <Modal
            open={openModal}
            title={`${messages['new_migration_import_from_account']} ${externalAccount && importSource.id.toUpperCase() !== "TSO" ? `(${externalAccount.name})` : externalAccount ? `(${externalAccount.Name})` : ''}`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <Tabs
                    tab={+tab}
                    disabled={true}
                >
                    <TabContainer disabled={true} index={0} label={messages['new_migration_source']}>
                        {
                            step === 1 && (
                                <div style={{ marginTop: 20, marginBottom: 5 }}>
                                    <Select
                                        id="select-sources"
                                        value={importSource}
                                        options={filteredSources}
                                        label={messages['new_migration_source']}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => {
                                            dispatch(clearRedux("IMPORT_ACCOUNT", { accountsList: [], migrationAccount: null, internalMigratedAccount: null }))

                                            setServer(null);
                                            setOpenSearch("");
                                            setExternalAccount(null);
                                            setNoSearch(false);
                                            setInternalAccount(null);
                                            setImportSource(value);
                                            setIntegrationMode(null);
                                            setPreviewLocked(false);
                                            setUpgradeConfirmOpen(false);
                                            setGtcAccount(null);
                                            setGtcEntities(GTC_ENTITY_KEYS.reduce((acc, key) => ({ ...acc, [key]: false }), {}));

                                            if (value?.id.toUpperCase() === "TSO") {
                                                setEntityTSO(true);
                                            } else {
                                                setEntityTSO(false);
                                            }

                                            if (value?.id === "P4") {
                                                setEntityP4(true);
                                            } else {
                                                setEntityP4(false);
                                            }

                                            if (value?.id === "GTC") {
                                                setEntityGTC(true);
                                            } else {
                                                setEntityGTC(false);
                                            }

                                        }}
                                        loading={loadingEntity}
                                        valueField="id"
                                        textField="label"
                                        placeholder={messages['select']}
                                    />
                                </div>
                            )
                        }
                        {
                            importSource?.id.toUpperCase() === "TSO" &&
                            <Form
                                ref={formRefTSO}
                                onValidSubmit={() => {
                                    if (!noSearch) {
                                        dispatch(importAccountSearchRequest({
                                            openSearch,
                                            sourcePlatform: importSource?.id.toUpperCase()
                                        }))
                                    }
                                }}
                            >
                                <div style={{ marginTop: 5 }}>
                                    <FormControl style={{ width: '100%' }}>
                                        <label className="input-normal-label">{messages['new_migration_account_name']}<span className="text-danger"> *</span></label>
                                        <OutlinedInput
                                            style={{ marginTop: 2, height: 42, fontSize: 'inherit', color: '#212529' }}
                                            className={`imports-search-accounts ${noSearch ? 'imports-search-accounts-error' : ''}`}
                                            disabled={false}
                                            id="custom-tso-search"
                                            placeholder={messages['new_migration_account_name']}
                                            type="text"
                                            value={openSearch || ''}
                                            fullWidth={true}
                                            onChange={(event) => {
                                                setNoSearch(false);
                                                setOpenSearch(event.target.value)
                                            }}
                                            required
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <div style={{
                                                        height: 40,
                                                        width: 34,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        cursor: 'pointer'
                                                    }}
                                                        onClick={() => {
                                                            if (!openSearch) setNoSearch(true)
                                                            else setNoSearch(false)
                                                            formRefTSO.current?.submit();
                                                        }}
                                                    >
                                                        <Icon>search</Icon>
                                                    </div>
                                                </InputAdornment>
                                            }
                                        />
                                        {noSearch && <small className="select-error text-danger">{messages['required_field']}</small>}
                                    </FormControl>
                                </div>
                                <label className="input-normal-label" style={{ marginTop: 8 }}>{messages['new_migration_records_found']}</label>
                                <div style={{
                                    width: '100%',
                                    marginTop: 10,
                                    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                                    borderRadius: 5,
                                    maxHeight: 300,
                                    overflowX: 'auto'
                                }}>
                                    {
                                        accountsList.length ? (
                                            <ul style={{ margin: 0, padding: 5 }}>
                                                {
                                                    accountsList.map((item, key) => {
                                                        return (
                                                            <li
                                                                key={key}
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    height: 40,
                                                                    cursor: 'pointer',
                                                                    backgroundColor: externalAccount?.CompanyID === item?.CompanyID && '#ccc',
                                                                    borderRadius: 5,
                                                                    padding: 5
                                                                }}
                                                                onClick={() => setExternalAccount(item)}
                                                            >
                                                                {`${item.CompanyID} - ${item.Name}`}
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        ) : (
                                            <div style={{
                                                display: 'flex',
                                                height: 30,
                                                width: '100%',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                color: '#212529',
                                                opacity: 0.6
                                            }}>
                                                {messages['new_migration_no_data_available']}
                                            </div>
                                        )
                                    }

                                </div>
                            </Form>
                        }
                    </TabContainer>
                    {
                        entityP4 &&
                        <TabContainer disabled={true} index={1} label={messages['new_migration_account']}>
                            <div style={{ marginTop: 10, marginBottom: 40 }}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => {
                                        if (!noSearch) {
                                            dispatch(importAccountSearchRequest({
                                                openSearch,
                                                sourcePlatform: server?.id
                                            }))
                                        }
                                    }}
                                >
                                    <Select
                                        id="select-server"
                                        value={server}
                                        options={[
                                            {
                                                id: "InTouchStaging",
                                                name: "InTouch Staging"
                                            },
                                            {
                                                id: "InTouchAlpha",
                                                name: "InTouch Alpha"
                                            },
                                            {
                                                id: "InTouchBeta",
                                                name: "InTouch Beta"
                                            },
                                            {
                                                id: "InTouchGamma",
                                                name: "InTouch Gamma"
                                            }
                                        ]}
                                        label={messages['new_migration_server']}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={setServer}
                                        loading={false}
                                        valueField="id"
                                        textField="name"
                                        placeholder={messages['select']}
                                    />
                                    <div style={{ marginTop: 5 }}>
                                        <FormControl style={{ width: '100%' }}>
                                            <label className="input-normal-label">{messages['new_migration_account_name']}<span className="text-danger"> *</span></label>
                                            <OutlinedInput
                                                style={{ marginTop: 2, height: 42, fontSize: 'inherit', color: '#212529' }}
                                                className={`imports-search-accounts ${noSearch ? 'imports-search-accounts-error' : ''}`}
                                                disabled={false}
                                                id="custom-search"
                                                placeholder={messages['new_migration_account_name']}
                                                type="text"
                                                value={openSearch || ''}
                                                fullWidth={true}
                                                onChange={(event) => {
                                                    setNoSearch(false);
                                                    setOpenSearch(event.target.value)
                                                }}
                                                required
                                                endAdornment={
                                                    <InputAdornment position="end">
                                                        <div style={{
                                                            height: 40,
                                                            width: 34,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            cursor: 'pointer'
                                                        }}
                                                            onClick={() => {
                                                                if (!openSearch) setNoSearch(true)
                                                                else setNoSearch(false)
                                                                formRef.current?.submit();
                                                            }}
                                                        >
                                                            <Icon>search</Icon>
                                                        </div>
                                                    </InputAdornment>
                                                }
                                            />
                                            {noSearch && <small className="select-error text-danger">{messages['required_field']}</small>}
                                        </FormControl>
                                    </div>
                                    <label className="input-normal-label" style={{ marginTop: 8 }}>{messages['new_migration_records_found']}</label>
                                    <div style={{
                                        width: '100%',
                                        marginTop: 10,
                                        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                                        borderRadius: 5,
                                        maxHeight: 300,
                                        overflowX: 'auto'
                                    }}>
                                        {
                                            accountsList.length ? (
                                                <ul style={{ margin: 0, padding: 5 }}>
                                                    {
                                                        accountsList.map((item, key) => {
                                                            return (
                                                                <li
                                                                    key={key}
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                        height: 40,
                                                                        cursor: 'pointer',
                                                                        backgroundColor: externalAccount?.id === item?.id && '#ccc',
                                                                        borderRadius: 5,
                                                                        padding: 5
                                                                    }}
                                                                    onClick={() => setExternalAccount(item)}
                                                                >
                                                                    {`${item.id} - ${item.name}`}
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            ) : (
                                                <div style={{
                                                    display: 'flex',
                                                    height: 30,
                                                    width: '100%',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    color: '#212529',
                                                    opacity: 0.6
                                                }}>
                                                    {messages['new_migration_no_data_available']}
                                                </div>
                                            )
                                        }

                                    </div>
                                </Form>
                            </div>
                        </TabContainer>
                    }
                    {
                        entityP4 &&
                        <TabContainer disabled={true} index={2} label={messages['new_migration_entities']}>
                            <div style={{ marginTop: 10 }}>
                                {
                                    status && (
                                        <Alert
                                            style={{ marginBottom: 5 }}
                                            severity="info"
                                        >
                                            {
                                                status === "MigrationNotExists"
                                                    && externalAccount?.name && newInternalAccount?.name === externalAccount?.name
                                                    ? <AlertTitle>{messages[status] || status}</AlertTitle> : <></>
                                            }
                                            { //MigrationNotExists_AccountNameExists
                                                status === "MigrationNotExists_AccountNameExists"
                                                    && externalAccount?.name && newInternalAccount?.name === externalAccount?.name
                                                    ? <AlertTitle>{messages[status] || status}</AlertTitle> : <></>
                                            }
                                            {
                                                status === "MigrationExists" ? messages[status] : <></>
                                            }
                                            {
                                                status === "MigrationNotExists"
                                                    && externalAccount?.name && newInternalAccount?.name !== externalAccount?.name
                                                    ? messages[status] || status : <></>
                                            }
                                            {externalAccount?.name && newInternalAccount?.name === externalAccount?.name &&
                                                `${messages['new_migration_account_registered']} ${externalAccount.name} ${messages['new_migration_in_px']}`
                                            }
                                        </Alert>
                                    )
                                }
                            </div>
                            {
                                (status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists") && (
                                    <div>
                                        <CustomSelect
                                            async
                                            value={internalAccount}
                                            onChange={setInternalAccount}
                                            label={messages['new_migration_pair_with_this_px']}
                                            loadOptions={getAccountsForSelect}
                                            loading={loadingAccounts}
                                            getOptionLabel={e => `${e.id} - ${e.name}`}
                                            getOptionValue={e => e.id}
                                        />
                                        {
                                            validateStatus &&
                                            <Alert
                                                style={{ marginTop: 5 }}
                                                severity="warning"
                                            >
                                                {messages['new_migration_verify_accounts']}
                                            </Alert>
                                        }
                                    </div>
                                )
                            }
                            <div style={{ marginTop: 10 }}>
                                <label className="input-normal-label">{messages['new_migration_entity_to_migrate']}</label>
                                <div style={{ width: '100%', display: 'grid', marginBottom: 30 }}>
                                    <Checkbox
                                        label={messages['new_migration_account']}
                                        className="itemCheck mb-0"
                                        type="checkbox"
                                        id="account-check"
                                        disabled={true}
                                        value={accounts}
                                        onChange={() => setAccounts(true)}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_contacts']}
                                        className="itemCheck mb-0"
                                        type="checkbox"
                                        id="contacts-check"
                                        value={contacts}
                                        onChange={setContacts}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_categories']}
                                        className="itemCheck mb-0"
                                        type="checkbox"
                                        id="categories-check"
                                        value={categories}
                                        onChange={setCategories}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_behavior']}
                                        className="itemCheck mb-0"
                                        type="checkbox"
                                        id="behavior-check"
                                        value={behavior}
                                        onChange={setBehavior}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_users']}
                                        className="itemCheck mb-0"
                                        type="checkbox"
                                        id="users-check"
                                        value={users}
                                        onChange={setUsers}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_drivers']}
                                        type="checkbox"
                                        id="drivers-check"
                                        value={drivers}
                                        onChange={setDrivers}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_devices']}
                                        type="checkbox"
                                        id="devices-check"
                                        value={devices}
                                        onChange={setDevices}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_geofences']}
                                        type="checkbox"
                                        id="geofences-check"
                                        value={geofences}
                                        onChange={setGeofences}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_alerts']}
                                        type="checkbox"
                                        id="alerts-check"
                                        value={alerts}
                                        onChange={setAlerts}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_maintenance']}
                                        type="checkbox"
                                        id="maintenance-check"
                                        value={maintenance}
                                        onChange={setMaintenance}
                                    />
                                    <Checkbox
                                        label={messages['new_migration_speed_override']}
                                        type="checkbox"
                                        id="speed-override-check"
                                        value={speedOverrides}
                                        onChange={setSpeedOverrides}
                                    />
                                </div>
                            </div>
                        </TabContainer>
                    }
                    {
                        entityTSO &&
                        <TabContainer disabled={true} index={1} label={messages['new_migration_entities']}>
                            <div style={{ marginTop: 10 }}>
                                {
                                    status && (
                                        <Alert
                                            style={{ marginBottom: 5 }}
                                            severity="info"
                                        >
                                            {
                                                status === "MigrationNotExists"
                                                    ? <AlertTitle>{messages[status] || status}</AlertTitle> : <></>
                                            }
                                            { //MigrationNotExists_AccountNameExists
                                                status === "MigrationNotExists_AccountNameExists"
                                                    ? <AlertTitle>{messages[status] || status}</AlertTitle> : <></>
                                            }
                                            {
                                                status === "MigrationExists" ? messages[status] : <></>
                                            }
                                            
                                            {externalAccount?.Name && newInternalAccount?.name.toLowerCase() === externalAccount?.Name.toLowerCase() &&
                                                `${messages['new_migration_account_registered']} ${externalAccount.Name} ${messages['new_migration_in_px']}`
                                            }
                                        </Alert>
                                    )
                                }
                            </div>
                            {
                                (status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists") && (
                                    <div>
                                        <CustomSelect
                                            async
                                            value={internalAccount}
                                            onChange={setInternalAccount}
                                            label={messages['new_migration_pair_with_this_px']}
                                            loadOptions={getAccountsForSelect}
                                            loading={loadingAccounts}
                                            getOptionLabel={e => `${e.id} - ${e.name}`}
                                            getOptionValue={e => e.id}
                                        />
                                        {
                                            validateStatus &&
                                            <Alert
                                                style={{ marginTop: 5 }}
                                                severity="warning"
                                            >
                                                {messages['new_migration_verify_accounts']}
                                            </Alert>
                                        }
                                    </div>
                                )
                            }
                            <div style={{ marginTop: 10, marginBottom: 40 }}>
                                {
                                    ENTITY_KEYS.map(key => (
                                        <div key={key}>
                                            <Checkbox
                                                label={messages[`new_migration_${key}`] || key}
                                                className="itemCheck mb-0"
                                                type="checkbox"
                                                id={`${key}-check`}
                                                value={entities[key]}
                                                disabled={key === "accounts"}
                                                onChange={() => handleCheckboxChange(key)}
                                            />
                                        </div>
                                    ))}
                            </div>
                        </TabContainer>
                    }
                    {
                        entityGTC &&
                        <TabContainer disabled={true} index={1} label={messages['new_migration_account']}>
                            <div style={{ marginTop: 10, marginBottom: 40, height: '500px' }}>
                                <div className="time-zone-container" style={{ marginTop: 10 }}>
                                    <CustomSelect
                                        async
                                        value={gtcAccount}
                                        onChange={(newaccount) => {
                                            setGtcAccount(newaccount);
                                            setIntegrationMode(null);
                                            setPreviewLocked(false);
                                            setUpgradeConfirmOpen(false);
                                            setGtcEntities(GTC_ENTITY_KEYS.reduce((acc, key) => ({ ...acc, [key]: false }), {}));
                                            dispatch(clearRedux("IMPORT_ACCOUNT", { migrationAccount: null, internalMigratedAccount: null }))
                                            setInternalAccount(null);
                                            if (newaccount)
                                                dispatch(importAccountGetMigrationAccountRequest({
                                                    externalCompanyId: newaccount.id,
                                                    sourceName: 'GTC_PX',
                                                    sourceEntityName: 'accounts'
                                                }));
                                        }}
                                        label={messages['new_migration_gtc_account_name']}
                                        loadOptions={getGtcAccountsForSelect}
                                        required
                                        getOptionLabel={e => e.name}
                                        getOptionValue={e => e.id}
                                        placeholder={messages['add_integration_account']}
                                        requiredMessage={messages['required_field']}
                                        menuPlacement="bottom"
                                        isClearable
                                    />
                                </div>
                                <div style={{ marginTop: '15px' }}>
                                    <CustomSelect
                                        async
                                        value={internalAccount}
                                        onChange={setInternalAccount}
                                        label={messages['new_migration_ignition_account_name']}
                                        loadOptions={getAccountsForSelect}
                                        loading={loadingAccounts}
                                        getOptionLabel={e => `${e.id} - ${e.name}`}
                                        getOptionValue={e => e.id}
                                        required
                                        requiredMessage={messages['required_field']}
                                        menuPlacement="bottom"
                                        isClearable
                                        // Si ya se migró la cuenta, deshabilitar selector
                                        isDisabled={!!migrationAccount}
                                    />
                                    {migrationAccount && (
                                        <Alert severity="info" style={{ marginTop: 10 }}>
                                            {messages['new_migration_account_already_linked']}
                                        </Alert>
                                    )}
                                </div>
                            </div>
                        </TabContainer>
                    }
                    {
                        entityGTC &&
                        <TabContainer disabled={true} index={2} label={messages['new_migration_mode']}>
                            <div style={{ marginTop: 10, marginBottom: 40 }}>
                                <Alert severity="info" style={{ marginBottom: 18 }}>
                                    <AlertTitle>{messages['new_migration_pair_with_this_gtc']}</AlertTitle>
                                    {gtcAccount?.id ? `${gtcAccount.id} - ${gtcAccount.name}` : ''}
                                </Alert>
                                {
                                    migrationAccount && migrationAccount.mode === 'upgrade' &&
                                    <Alert severity="info" style={{ marginBottom: 18 }}>
                                        <AlertTitle>{messages['new_migration_upgrade_already_done']}</AlertTitle>
                                    </Alert>
                                }

                                <div className="new-migration-mode__title">
                                    {messages['new_migration_select_integration_mode']}
                                </div>

                                <div
                                    className={`new-migration-mode-card ${(migrationAccount?.mode === 'upgrade') ? 'is-disabled' : ''}`}
                                    role="button"
                                    tabIndex={(migrationAccount?.mode === 'preview' || migrationAccount?.mode === 'upgrade') ? -1 : 0}
                                    aria-disabled={migrationAccount?.mode === 'upgrade'}
                                    onClick={() => requestIntegrationModeChange('preview')}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            requestIntegrationModeChange('preview')
                                        }
                                    }}
                                >
                                    <div className="new-migration-mode-card__left">
                                        <Radio
                                            checked={integrationMode === 'preview'}
                                            onChange={() => requestIntegrationModeChange('preview')}
                                            disabled={migrationAccount?.mode === 'preview' || migrationAccount?.mode === 'upgrade'}
                                        />
                                        <div>
                                            <div className="new-migration-mode-card__title">{messages['new_migration_preview_mode']}</div>
                                            <div className="new-migration-mode-card__subtitle">GTC → Ignition</div>
                                            <div className="new-migration-mode-card__desc">{messages['new_migration_preview_mode_desc']}</div>
                                        </div>
                                    </div>
                                    <Icon>arrow_forward</Icon>
                                </div>

                                <div
                                    className={`new-migration-mode-card ${migrationAccount?.mode === 'upgrade' ? 'is-disabled' : ''}`}
                                    role="button"
                                    tabIndex={migrationAccount?.mode === 'upgrade' ? -1 : 0}
                                    aria-disabled={migrationAccount?.mode === 'upgrade'}
                                    onClick={() => requestIntegrationModeChange('upgrade')}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            requestIntegrationModeChange('upgrade')
                                        }
                                    }}
                                >
                                    <div className="new-migration-mode-card__left">
                                        <Radio
                                            checked={integrationMode === 'upgrade'}
                                            onChange={() => requestIntegrationModeChange('upgrade')}
                                            disabled={migrationAccount?.mode === 'upgrade'}
                                        />
                                        <div>
                                            <div className="new-migration-mode-card__title">{messages['new_migration_upgrade_mode']}</div>
                                            <div className="new-migration-mode-card__subtitle">Ignition → GTC</div>
                                            <div className="new-migration-mode-card__desc">{messages['new_migration_upgrade_mode_desc']}</div>
                                        </div>
                                    </div>
                                    <Icon>arrow_back</Icon>
                                </div>
                            </div>
                        </TabContainer>
                    }
                    {
                        entityGTC &&
                        <TabContainer disabled={true} index={3} label={messages['new_migration_entities']}>
                            <div style={{ marginTop: 10, marginBottom: 40 }}>
                                {(() => {
                                    const isUpgrade = integrationMode === 'upgrade';

                                    return (
                                        <>
                                            <Alert severity="info" style={{ marginBottom: 18 }}>
                                                <AlertTitle>{messages['new_migration_pair_with_this_gtc']}</AlertTitle>
                                                <div>
                                                    {gtcAccount?.id ? `${gtcAccount.id} - ${gtcAccount.name}` : ''}
                                                </div>
                                                <div>
                                                    {messages['new_migration_mode_label']}: {integrationMode === 'upgrade' ? messages['new_migration_upgrade_mode'] : messages['new_migration_preview_mode']}
                                                </div>
                                            </Alert>

                                            <div className="new-migration-mode__title">
                                                {isUpgrade
                                                    ? messages['new_migration_entities_auto_synced']
                                                    : messages['new_migration_select_entities_to_sync']}
                                            </div>

                                            {isUpgrade && (
                                                <Alert
                                                    severity="info"
                                                    variant="outlined"
                                                    icon={false}
                                                    style={{ marginBottom: 14 }}
                                                >
                                                    {messages['new_migration_upgrade_entities_locked']}
                                                </Alert>
                                            )}

                                            {!isUpgrade && gtcEntities.devices && !gtcEntities.asset && !gtcEntities.driver && !gtcEntities.user && (
                                                <Alert
                                                    severity="warning"
                                                    style={{ marginBottom: 14 }}
                                                >
                                                    {messages['new_migration_preview_units_only_warning']}
                                                </Alert>
                                            )}

                                            <div style={{ width: '100%', display: 'grid' }}>
                                                <Checkbox
                                                    label={messages['new_migration_units']}
                                                    type="checkbox"
                                                    id="gtc-units-check"
                                                    value={isUpgrade ? true : gtcEntities.devices}
                                                    disabled={isUpgrade}
                                                    onChange={() => {
                                                        if (!isUpgrade) toggleGtcEntity('devices')
                                                    }}
                                                />
                                                <Checkbox
                                                    label={messages['new_migration_assets']}
                                                    type="checkbox"
                                                    id="gtc-assets-check"
                                                    value={isUpgrade ? true : gtcEntities.asset}
                                                    disabled={isUpgrade}
                                                    onChange={() => {
                                                        if (!isUpgrade) toggleGtcEntity('asset')
                                                    }}
                                                />
                                                <Checkbox
                                                    label={messages['new_migration_drivers']}
                                                    type="checkbox"
                                                    id="gtc-drivers-check"
                                                    value={isUpgrade ? true : gtcEntities.driver}
                                                    disabled={isUpgrade}
                                                    onChange={() => {
                                                        if (!isUpgrade) toggleGtcEntity('driver')
                                                    }}
                                                />
                                                <Checkbox
                                                    label={messages['new_migration_users']}
                                                    type="checkbox"
                                                    id="gtc-users-check"
                                                    value={isUpgrade ? true : gtcEntities.user}
                                                    disabled={isUpgrade}
                                                    onChange={() => {
                                                        if (!isUpgrade) toggleGtcEntity('user')
                                                    }}
                                                />

                                            </div>
                                        </>
                                    )
                                })()}
                            </div>
                        </TabContainer>
                    }
                </Tabs>
            </ModalBody>

            <Dialog
                open={upgradeConfirmOpen}
                onClose={() => setUpgradeConfirmOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle className="new-migration-upgrade-dialog__title">
                    <div className="new-migration-upgrade-dialog__title-row">
                        <Icon color="warning">warning_amber</Icon>
                        <span>{messages['new_migration_convert_to_upgrade_title']}</span>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className="new-migration-upgrade-dialog__desc">
                        {messages['new_migration_convert_to_upgrade_desc']}
                    </div>

                    <Alert severity="warning" style={{ marginTop: 14 }}>
                        <div className="new-migration-upgrade-dialog__what">
                            {messages['new_migration_what_will_happen']}
                        </div>
                        <ul className="new-migration-upgrade-dialog__list">
                            <li>{messages['new_migration_upgrade_bullet_sync_all_entities']}</li>
                            <li>{messages['new_migration_upgrade_bullet_sync_every_24h']}</li>
                            <li>{messages['new_migration_upgrade_bullet_no_switch_back']}</li>
                            <li>{messages['new_migration_upgrade_bullet_permanent']}</li>
                        </ul>
                    </Alert>

                    <div className="new-migration-upgrade-dialog__question">
                        {messages['new_migration_are_you_sure']}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="btn btn-cancel"
                        onClick={() => setUpgradeConfirmOpen(false)}
                    >
                        {messages['new_migration_cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={() => {
                            setIntegrationMode('upgrade');
                            setPreviewLocked(true);
                            setGtcEntities(GTC_ENTITY_KEYS.reduce((acc, key) => ({ ...acc, [key]: true }), {}));
                            setUpgradeConfirmOpen(false);
                        }}
                    >
                        {messages['new_migration_confirm_convert_upgrade']}
                    </Button>
                </DialogActions>
            </Dialog>

            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => {

                        if (tab === 1) {
                            setContacts(false);
                            setCategories(false);
                            setBehavior(false);
                            setUsers(false);
                            setDevices(false);
                            setGeofences(false);
                            setMaintenance(false);
                            setDrivers(false);
                            setTab(0);
                            //setInternalAccount(null);
                            setSpeedOverrides(false);
                            //setImportSource(null);
                            //setEntityP4(false);
                            //setEntityTSO(false);
                            //resetCbx();
                        } else if (tab === 2) {
                            setTab(1);
                        } else if (tab === 3) {
                            setTab(2);
                        } else closeModal()
                    }}
                >
                    {tab > 0 ? messages['common_back'] : messages['close']}
                </Button>
                <Button
                    //disabled={importSource === null || externalAccount === null || ((status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists") && validateStatus)}
                    //disabled={importSource === null || (importSource.id.toUpperCase() === "TSO" && externalAccount === null) || ((step === 2) && (externalAccount === null || ((status === "MigrationNotExists" || status === "MigrationNotExists_AccountNameExists") && validateStatus)))}
                    disabled={importSource === null ||
                        (importSource.id.toUpperCase() === "TSO" && externalAccount === null) ||
                        (importSource.id.toUpperCase() === "P4" && (tab === 1 && (externalAccount === null || server === null))) ||
                        (importSource.id.toUpperCase() === "GTC" && (tab === 1 && (gtcAccount === null || internalAccount === null))) ||
                        (importSource.id.toUpperCase() === "GTC" && (tab === 2 && integrationMode === null)) ||
                        (
                            importSource.id.toUpperCase() === "GTC" && (tab === 2 && migrationAccount?.mode === 'upgrade')
                        )
                        || (
                            importSource.id.toUpperCase() === "GTC" &&
                            tab === 3 &&
                            integrationMode !== 'upgrade' &&
                            Object.values(gtcEntities).every(v => !v)
                        )
                        // In preview mode, if only devices is selected, require at least one other entity
                        || (
                            importSource.id.toUpperCase() === "GTC" &&
                            tab === 3 &&
                            integrationMode === 'preview' &&
                            gtcEntities.devices &&
                            !gtcEntities.asset &&
                            !gtcEntities.driver &&
                            !gtcEntities.user
                        )
                        // Si ya se hizo upgrade, deshabilitar el botón de importar
                        || (importSource.id.toUpperCase() === "GTC" && migrationAccount?.mode === 'upgrade' && tab === 3)
                    }
                    className="btn-dark-blue"
                    onClick={() => {

                        if (importSource.id.toUpperCase() === "P4") {
                            if (tab === 0) {
                                setTab(1)
                                return
                            } else if (tab === 1) {
                                if (externalAccount?.id) {
                                    dispatch(importAccountGetStatusRequest({
                                        externalCompanyId: externalAccount?.id,
                                        sourcePlatform: server.id
                                    }))
                                }
                                setTab(2)
                                return
                            } else if (tab === 2) {
                                handleSaveP4()
                                return
                            }
                        }

                        if (importSource.id.toUpperCase() === "TSO") {
                            if (tab === 0) {
                                if (externalAccount?.CompanyID) {
                                    dispatch(importAccountGetStatusRequest({
                                        externalCompanyId: externalAccount?.CompanyID,
                                        sourcePlatform: importSource.id
                                    }))
                                }
                                setTab(1)
                                return
                            } else if (tab === 1) {
                                handleSaveTSO()
                                return
                            }
                        }

                        if (importSource.id.toUpperCase() === "GTC") {
                            if (tab === 0) {
                                setTab(1)
                                return
                            } else if (tab === 1) {
                                setTab(2)
                                return
                            } else if (tab === 2) {
                                setTab(3)
                                return
                            } else if (tab === 3) {
                                handleSaveGTC()
                                return
                            }

                        }
                        if (step === 2 && importSource.id.toUpperCase() === "TSO") {
                            handleSaveTSO()
                            return
                        }

                    }}
                >
                    {importSource?.id?.toUpperCase() === "P4" ? (tab > 1 ? messages['new_migration_import'] : messages['common_next']) : importSource?.id?.toUpperCase() === "TSO" ? (tab === 1 ? messages['new_migration_import'] : messages['common_next']) : importSource?.id?.toUpperCase() === "GTC" ? (tab === 3 ? messages['new_migration_import'] : messages['common_next']) : messages['common_next']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default NewMigration